 <template>
  <!-- you can rename class or id for this component, please put your comment what you need for styling needs -->
  <div :class="nameclass || 'optionsDefaultClass'" style="padding-left:100px">
    <!-- for each component have default label and classname, 
    you can inherit when you call the component-->
    <b-form-group>
      <b-form-checkbox
        @input="(event) => {
          $emit('update', event);}"
        class="form-group form-check"
        v-for="option in TransactionType"
        v-model="selected"
        :key="option.id"
        :value="option.id"
        name="flavour-4a"
        stacked
      >{{ option.name }}</b-form-checkbox>
    </b-form-group>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  inheritAttrs: false,
  props: ["value", "nameclass", "label"],
  model: {
    prop: "value",
    event: "update"
  },
  data() {
    return {
      selected: [this.value]
    };
  },
  mounted() {},
  computed: mapState(["TransactionType"]),
  async created() {
    await this.$store.dispatch("loadTransactionType");
  },
  watch: {
    value: function(updated, old) {
      if (updated) {
        this.selected = updated;
      }
    }
  }
};
</script>